// extracted by mini-css-extract-plugin
export default {"grid":"SpotlightsGridFullWidth_grid__IFE7T"};